/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_OFFER, PAGE_THREATS, PAGE_ESTIMATION } from '../../../config/pages';
// import List from '../../helpers/List';

const HomeBox = ({
    t, page, type, mouse, mouseActive, mousePercent, boxClick, scrollToContent, noTransition, ctas
}) => {
    const boxClassName = cx('home-box', `home-box-${ type }`, {
        'mouse-move': mouse,
        'mouse-active': mouseActive,
        open: (page === PAGE_OFFER || page === PAGE_THREATS) && type === page,
        closed: (page === PAGE_OFFER || page === PAGE_THREATS) && type !== page,
        'no-transition': noTransition
    });
    const buttonClassName = cx('button', {
        'button-white': type === PAGE_THREATS && (type === PAGE_OFFER && process.env.DEFAULT_LANGUAGES === 'de'),
        'button-gray': type === PAGE_OFFER && (process.env.DEFAULT_LANGUAGES === 'en' || process.env.DEFAULT_LANGUAGES === 'pl')
    });
    const percent = mouseActive ? mousePercent : (-1.0) * mousePercent;
    const boxStyle = mouse ? {
        width: `${ (50 + (percent * 6)) }%`,
        top: 20 - (percent * 20),
        bottom: 20 - (percent * 20)
    } : {};

    return (
        <div className={ boxClassName } id="button-button" style={ boxStyle }>
            <div className="home-box-bg"/>
            <div className="home-box-excerpt has-transition">
                <h2 dangerouslySetInnerHTML={ { __html: t(`home.${ type }.excerpt.title`) } }/>
                { /* <List data={ t(`home.${ type }.excerpt.list`) }/> */ }
                <div className="home-box-excerpt-button-box">
                    {ctas.map((cta, index) => (
                        <div className="button-box" key={ index }>
                            <span
                              onClick={ () => boxClick(cta.type) }
                              className={ buttonClassName }
                              id={ `home-box-button-${ cta.type }` }
                            >{cta.text }
                            </span>
                        </div>))}
                    {/* <div className="button-box">
                        <span onClick={ () => boxClick(type) } className={ buttonClassName } id={ `home-box-button-${ type }` }>{ t(`home.${ type }.excerpt.button`) }</span>
                    </div>
                    {type === PAGE_OFFER &&
                    <div className="button-box">
                        <span onClick={ () => boxClick(PAGE_ESTIMATION) } className={ buttonClassName } id={ `home-box-link-${ PAGE_ESTIMATION }` }>{ t(`home.${ type }.excerpt.button_pricing`) }</span>
                    </div>} */}
                </div>
            </div>
            <div className="home-box-content has-transition">
                <h2 dangerouslySetInnerHTML={ { __html: t(`home.${ type }.content.title`) } }/>
                <p dangerouslySetInnerHTML={ { __html: t(`home.${ type }.content.description`) } }/>
                <div className="button-box">
                    <span className={ buttonClassName } id={ `content-${ type }` } onClick={ scrollToContent }>{ t(`home.${ type }.content.button`) } </span>
                </div>
            </div>
            <div className="home-box-scroll has-transition" onClick={ scrollToContent }/>
        </div>
    );
};

HomeBox.propTypes = {
    t: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    type: PropTypes.oneOf([PAGE_THREATS, PAGE_OFFER]).isRequired,
    ctas: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        type: PropTypes.oneOf([PAGE_THREATS, PAGE_OFFER, PAGE_ESTIMATION])
    })).isRequired,
    mouse: PropTypes.bool.isRequired,
    mouseActive: PropTypes.bool.isRequired,
    mousePercent: PropTypes.number.isRequired,
    boxClick: PropTypes.func.isRequired,
    scrollToContent: PropTypes.func.isRequired,
    noTransition: PropTypes.bool.isRequired
};

export default HomeBox;



// WEBPACK FOOTER //
// ./src/components/content/home/HomeBox.jsx